import React from 'react';
import './BergButton.scss';
import getClientsStyle from '../../../utils/getClientsStyle';
interface IButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  color?:
    | 'primary'
    | 'secondary'
    | 'orange'
    | 'primary-dark'
    | 'gray-400'
    | 'white'
    | 'green'
    | 'border'
    | 'full';

  backgroundColor?: string;

  label: string;

  onClick?: (e: React.SyntheticEvent) => void;
  type?: 'button' | 'submit' | 'reset';
}

const BergButton = ({
  color,
  backgroundColor,
  label,
  type,
  ...rest
}: IButtonProps) => {
  const colorClass = `berg-button__${color ?? 'primary'}`;
  const styleForClient = getClientsStyle();
  return (
    <button
      data-client-style={styleForClient}
      type={type}
      className={['berg-button', colorClass].join(' ')}
      style={{ backgroundColor }}
      {...rest}
    >
      {label}
    </button>
  );
};

export default BergButton;
